import {
  Alert,
  AlertIcon,
  AlertTitle,
  useToast as useChakraToast,
  UseToastOptions,
} from '@chakra-ui/react'
import { useCallback, useMemo } from 'react'
import ErrorCircleX from 'src/components/icons/ErrorCircleX'

export const useToast = () => {
  const defaultOptions: UseToastOptions = useMemo(
    () => ({
      position: 'top',
      variant: 'solid',
    }),
    [],
  )
  const chakraToast = useChakraToast(defaultOptions)

  return useCallback(
    (options: UseToastOptions) => {
      if (options.status === 'error' && !options.render) {
        return chakraToast({
          ...options,
          render: () => (
            <Alert status="error" variant="solid" borderRadius="md" alignItems="center">
              <AlertIcon boxSize={4} m={0} mr={3}>
                <ErrorCircleX width="100%" height="100%" />
              </AlertIcon>
              <AlertTitle whiteSpace="pre-line">{options.title}</AlertTitle>
            </Alert>
          ),
        })
      }
      return chakraToast(options)
    },
    [chakraToast],
  )
}
